const bridge = () => typeof window !== "undefined" ? window.desktopOfflineParties : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline customer storage.");
  return api;
};

export const listOfflineParties = (restaurantId, activeOnly = false) =>
  requireBridge().list({ restaurantId, activeOnly });
export const createOfflineParty = (restaurantId, party) =>
  requireBridge().create({ restaurantId, party });
export const updateOfflineParty = (restaurantId, partyId, party) =>
  requireBridge().update({ restaurantId, partyId, party });
export const deleteOfflineParty = (restaurantId, partyId) =>
  requireBridge().remove({ restaurantId, partyId });
export const partyIdForPayload = (value) => {
  const key = String(value ?? "").trim();
  const numeric = Number(key);
  return key && Number.isFinite(numeric) ? numeric : key || null;
};
